import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";
import { getReferenceDataOptions } from "../../../../services/coreServicesCalls";

const sliceName = "appData/impactFactorSearchKind";
const impactFactorSearchKindSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(impactFactorSearchKindThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(impactFactorSearchKindThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(impactFactorSearchKindThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const impactFactorSearchKindThunk = createAsyncThunk(
  `${sliceName}/impactFactorSearchKindThunk`,
  async () => {
    const response = await getReferenceDataOptions("IMPACT_FACTOR_SEARCH_TYPE")();
    return response;
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.ImpactFactorSearchKind);
    },
  },
);

export default impactFactorSearchKindSlice.reducer;
